"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _lodash = _interopRequireDefault(require("lodash"));
var _basic = _interopRequireDefault(require("./_basic"));
var _error = require("./error");
class BasicDataHubApi extends _basic.default {
  /**
   * @constructor
   */
  constructor(_ref) {
    let {
      dataHubUrl,
      userTokenFactory,
      onGraphQLErrors,
      onNetworkError,
      accountId,
      defaultLimit,
      accountIdFactory,
      feature
    } = _ref;
    super({
      userTokenFactory,
      accountIdFactory
    });
    this.dataHubUrl = dataHubUrl;
    this.graphqlUrl = `${dataHubUrl}/graphql`;
    this.onGraphQLErrors = onGraphQLErrors;
    this.onNetworkError = onNetworkError;
    this.accountId = accountId;
    this.defaultLimit = defaultLimit || 30;
    this.feature = feature;
    this._createAxios();
  }
  get defaultLimit() {
    return this._defaultLimit;
  }
  set defaultLimit(value) {
    this._defaultLimit = value;
  }
  _getMethodName(name) {
    return this.accountId ? `${name}CrossAccount` : name;
  }
  async _callApi(_ref2) {
    let {
      method = 'GET',
      path = '',
      payload,
      queryParams = {},
      errorData = {},
      errorName
    } = _ref2;
    const {
      headers
    } = await this.getHeaders();
    queryParams.accountId = _lodash.default.isFunction(this._accountIdFactory) && this._accountIdFactory() || this.accountId;
    if (this.feature && this.feature !== 'master') queryParams.feature = this.feature;
    try {
      const {
        data: responseBody
      } = await this._axios({
        method,
        url: path,
        data: JSON.stringify(payload),
        params: _lodash.default.mapValues(queryParams, value => _lodash.default.isArray(value) ? JSON.stringify(value) : value),
        headers,
        maxContentLength: Infinity,
        maxBodyLength: Infinity
      });
      return responseBody;
    } catch (error) {
      const errorMessage = error.response?.data?.message ?? error.response?.data?.error ?? error.message;
      throw new _error.BasicError(errorMessage, {
        statusCode: error.response?.status,
        config: error.response?.config,
        headers: error?.response?.headers,
        errorData: error.response?.data ?? error,
        ...errorData
      }, errorName);
    }
  }
  _createAxios() {
    let {
      baseUrl
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this._axios = _axios.default.create({
      baseURL: baseUrl || this.dataHubUrl
      // paramsSerializer: params => Object.entries(params)
      //     // eslint-disable-next-line no-unused-vars
      //     .filter(([key, value]) => value !== undefined)
      //     .map(([key, value]) => `${key}=${typeof value === 'object' ? JSON.stringify(value) : value}`)
      //     .join('&')
    });
  }

  // eslint-disable-next-line class-methods-use-this
  setDiff(item, diff) {
    item = _lodash.default.cloneDeep(item);
    // eslint-disable-next-line no-unused-vars
    for (const key in diff) _lodash.default.set(item, key, diff[key]);
    return item;
  }
}
var _default = BasicDataHubApi;
exports.default = _default;